// BE: POST /api/v1/global-order-collections/collect (LOGISPRD-9611)
// 1.0 "수집" 버튼(RTV_DO_FR_PLT) 2.0 전환. 동기 응답 — 결과 요약을 즉시 받는다.
// 조회와 완전히 분리된 동작이다 — 성공 후 조회 결과를 자동 갱신하지 않는다(1.0 파리티).
import request from '@/utils/request'
import { menuCodeHeaders } from '@/utils/menuCodeHeaders'
import { toCollectParams } from './mapping'
import type { CollectFormValues, CollectGlobalOrderParams, CollectGlobalOrderResult } from './mapping'

/**
 * 수집 요청 타임아웃(ms). 전역 기본값은 100초인데(`utils/request.ts:33`) 이 호출은 BE 가 동기로 처리한다.
 * `CollectGlobalOrderService` 가 Bizest 배송주문을 최대 100페이지 순회하고 SKU 매핑까지 한 트랜잭션에
 * 저장하므로 100초를 넘길 수 있다. 그때 axios 가 먼저 끊으면 화면은 실패로 보이는데 BE 트랜잭션은
 * 그대로 커밋돼, 운영자가 수집을 다시 눌러 두 수집이 겹친다. 끊지 않고 기다리는 쪽이 안전하다.
 */
const COLLECT_TIMEOUT_MS = 10 * 60 * 1000

export const collectGlobalOrders = async (values: CollectFormValues): Promise<CollectGlobalOrderResult> => {
  const res = await request.post<ApiResponseV2<CollectGlobalOrderResult>, CollectGlobalOrderParams>(
    '/api/v1/global-order-collections/collect',
    toCollectParams(values),
    // 1.0 GL02 도 같은 API 를 헤더 없이 부른다 — BE 는 X-Menu-Code 가 GL14 일 때만 감사 로그를 남긴다(LOGISPRD-16047)
    { timeout: COLLECT_TIMEOUT_MS, ...menuCodeHeaders('GL14') },
  )
  return res.data
}
